// components/Loader.jsx
import Spinner from "components/spinner";
import React from "react";

const LoaderButton = ({
  children,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  variant = "primary", // default
  isLoading = false,
}) => {
  const baseClasses =
    "relative flex items-center justify-center rounded-md px-2 py-1.5 text-sm font-medium transition duration-200";

  const variantClasses = {
    primary:
      "border border-brand-500 bg-brand-500 text-white hover:bg-brand-600 active:bg-brand-700 dark:border-brand-400 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200",
    outline:
      "border border-brand-500 bg-transparent text-brand-500 hover:bg-brand-500 hover:text-white active:bg-brand-600 dark:border-brand-400 dark:text-brand-400 dark:hover:bg-brand-400 dark:hover:text-white dark:active:bg-brand-300",
    red: "border-red-600 bg-red-600 text-white hover:bg-red-700 active:bg-red-800 dark:border-red-500 dark:bg-red-500 dark:hover:bg-red-600 dark:active:bg-red-600",
    orange:
      "border-orange-600 bg-orange-600 text-white hover:bg-orange-700 active:bg-orange-800 dark:border-orange-500 dark:bg-orange-500 dark:hover:bg-orange-600 dark:active:bg-orange-600",
    green:
      "border-green-600 bg-green-600 text-white hover:bg-green-700 active:bg-green-800 dark:border-green-500 dark:bg-green-500 dark:hover:bg-green-600 dark:active:bg-green-600",
  };

  const disabledClasses =
    disabled || isLoading ? "cursor-not-allowed opacity-50" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`}
    >
      {/* Keep text space reserved */}
      <span className={isLoading ? "opacity-0" : "opacity-100"}>
        {children}
      </span>

      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Spinner />
        </span>
      )}
    </button>
  );
};

export default LoaderButton;
